import React, { useState } from "react";
import {
  Backdrop,
  Box,
  IconButton,
  Grid,
  Modal,
  Tooltip,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import {
  BCPEnvelope,
  BCPFacebook,
  BCPLinkSimple,
  BCPTwitterX,
  BCPXmark
} from "../icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { useTranslation } from "react-i18next";
const FACEBOOK_APP_ID = getEnvironmentVariable("FACEBOOK_APP_ID");

export default function ShareModal(props) {
  const { label, url, shareOptions, parentOpen, setParentOpen, linkOnly } =
    props;
  const [open, setOpen] = useState(false);
  const [toolTip, setToolTip] = useState("copy");

  const { t } = useTranslation("translation", {
    keyPrefix: "components.ShareModal"
  });

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      color: "#ffffff",
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11
    }
  }));

  return (
    <Modal
      disableAutoFocus
      open={Boolean(setParentOpen) ? parentOpen : open}
      onClose={() => {
        if (setParentOpen) setParentOpen(false);
        else setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "modal.background",
          color: "modal.text",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          textAlign: "center"
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            if (setParentOpen) setParentOpen(false);
            else setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              {label || t("shareWithFriends")}
            </Typography>
          </Grid>
        </Grid>
        <Box>
          {FACEBOOK_APP_ID !== undefined && !linkOnly && (
            <IconButton
              color="primary"
              onClick={() => {
                window.open(
                  `https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&display=popup&href=${url}`,
                  "popup",
                  "width=600,height=600"
                );
              }}
            >
              <BCPFacebook />
            </IconButton>
          )}
          {!linkOnly && (
            <IconButton
              color="primary"
              onClick={() => {
                window.open(
                  shareOptions?.twitter ||
                    `http://twitter.com/share?text=Checkout @BCPairings&url=${url}&hashtags=BestCoastPairings`,
                  "popup",
                  "width=600,height=600"
                );
              }}
            >
              <BCPTwitterX />
            </IconButton>
          )}

          {!linkOnly && (
            <IconButton
              color="primary"
              href={
                shareOptions?.email ||
                `mailto:?subject=Checkout ${getEnvironmentVariable(
                  "COMPANY_NAME"
                )}&body=Checkout ${getEnvironmentVariable(
                  "COMPANY_NAME"
                )} ${url}`
              }
            >
              <BCPEnvelope />
            </IconButton>
          )}

          <LightTooltip
            title={toolTip}
            PopperProps={{
              disablePortal: true,
              popperOptions: {
                positionFixed: true,
                modifiers: {
                  preventOverflow: {
                    enabled: true,
                    boundariesElement: "window"
                  }
                }
              }
            }}
          >
            <IconButton
              color="primary"
              onClick={() => {
                navigator.clipboard.writeText(url);
                setToolTip("copied!");
                setTimeout(() => {
                  setToolTip("copy");
                }, 2000);
              }}
              edge="end"
            >
              <BCPLinkSimple />
            </IconButton>
          </LightTooltip>
        </Box>
      </Box>
    </Modal>
  );
}
